const ROLE_TEMPLATES = [
  { vi: 'Chuyên viên {keyword}', en: '{keyword} Specialist' },
  { vi: 'Chuyên viên phân tích {keyword}', en: '{keyword} Analyst' },
  { vi: 'Điều phối {keyword}', en: '{keyword} Coordinator' },
  { vi: 'Quản lý {keyword}', en: '{keyword} Manager' },
  { vi: 'Trưởng nhóm {keyword}', en: '{keyword} Team Lead' },
  { vi: 'Chiến lược {keyword}', en: '{keyword} Strategist' },
  { vi: 'Tư vấn {keyword}', en: '{keyword} Consultant' },
  { vi: 'Lập kế hoạch {keyword}', en: '{keyword} Planner' },
  { vi: 'Đào tạo {keyword}', en: '{keyword} Trainer' },
  { vi: 'Nghiên cứu {keyword}', en: '{keyword} Researcher' },
  { vi: 'Thiết kế {keyword}', en: '{keyword} Designer' },
  { vi: 'Kỹ sư {keyword}', en: '{keyword} Engineer' },
  { vi: 'Sản xuất {keyword}', en: '{keyword} Producer' },
  { vi: 'Vận hành {keyword}', en: '{keyword} Operations' },
  { vi: 'Giám đốc {keyword}', en: '{keyword} Director' }
];

const buildRoadmap = (focus) => ({
  vi: [
    `Tuần 1: Xác định mục tiêu và phạm vi ${focus.vi}.`,
    `Tuần 2: Ôn nền tảng kiến thức cốt lõi về ${focus.vi}.`,
    `Tuần 3: Rèn kỹ năng công cụ/khung làm việc trong ${focus.vi}.`,
    `Tuần 4: Thực hành case study thực tế cho ${focus.vi}.`,
    `Tuần 5: Mở rộng kiến thức chuyên sâu về ${focus.vi}.`,
    `Tuần 6: Xây portfolio hoặc dự án nhỏ liên quan ${focus.vi}.`,
    `Tuần 7: Học kỹ năng phối hợp và giao tiếp trong ${focus.vi}.`,
    `Tuần 8: Tối ưu quy trình, đo lường hiệu quả ${focus.vi}.`,
    `Tuần 9: Chuẩn hóa CV/LinkedIn theo định hướng ${focus.vi}.`,
    `Tuần 10: Phỏng vấn thử và chốt lộ trình phát triển ${focus.vi}.`
  ],
  en: [
    `Week 1: Define goals and scope for ${focus.en}.`,
    `Week 2: Review core fundamentals of ${focus.en}.`,
    `Week 3: Practice tools and frameworks used in ${focus.en}.`,
    `Week 4: Apply real-world case studies for ${focus.en}.`,
    `Week 5: Deepen advanced knowledge in ${focus.en}.`,
    `Week 6: Build a mini project or portfolio for ${focus.en}.`,
    `Week 7: Improve collaboration and communication in ${focus.en}.`,
    `Week 8: Optimize processes and measure outcomes in ${focus.en}.`,
    `Week 9: Update CV/LinkedIn toward ${focus.en}.`,
    `Week 10: Mock interviews and finalize growth roadmap for ${focus.en}.`
  ]
});

const buildCluster = ({ id, title, summary, keyword, tags, skillsCore, focus }) => {
  const roadmap_10w = buildRoadmap(focus);
  const roles = ROLE_TEMPLATES.map((template, index) => ({
    id: `${id}-role-${index + 1}`,
    name: {
      vi: template.vi.replace('{keyword}', keyword.vi),
      en: template.en.replace('{keyword}', keyword.en)
    },
    tags,
    skills_core: skillsCore,
    roadmap_10w
  }));

  return {
    id,
    title,
    summary,
    tags,
    skills_core: skillsCore,
    roadmap_10w,
    roles
  };
};

export const DOMINANT_ELEMENT_CAREERS = {
  'Mộc': {
    element: { vi: 'Mộc', en: 'Wood' },
    clusters: [
      buildCluster({
        id: 'moc-education',
        title: { vi: 'Giáo dục & Đào tạo', en: 'Education & Training' },
        summary: {
          vi: 'Nuôi dưỡng con người và tri thức dài hạn, phù hợp thiên hướng phát triển bền vững.',
          en: 'Nurtures people and long-term knowledge growth with sustainable impact.'
        },
        keyword: { vi: 'giáo dục', en: 'Education' },
        tags: {
          vi: ['đào tạo', 'phát triển con người', 'truyền đạt', 'mentor', 'học tập'],
          en: ['training', 'people development', 'teaching', 'mentoring', 'learning']
        },
        skillsCore: {
          vi: ['sư phạm', 'thiết kế chương trình', 'coaching', 'đánh giá năng lực', 'truyền cảm hứng'],
          en: ['pedagogy', 'curriculum design', 'coaching', 'assessment', 'inspiration']
        },
        focus: { vi: 'giáo dục và đào tạo', en: 'education and training' }
      }),
      buildCluster({
        id: 'moc-product',
        title: { vi: 'Sản phẩm & UX', en: 'Product & UX' },
        summary: {
          vi: 'Xây trải nghiệm người dùng dài hạn, chú trọng tăng trưởng bền vững.',
          en: 'Builds enduring user experiences with sustainable growth.'
        },
        keyword: { vi: 'sản phẩm', en: 'Product' },
        tags: {
          vi: ['UX', 'research', 'tăng trưởng', 'khách hàng', 'tối ưu trải nghiệm'],
          en: ['UX', 'research', 'growth', 'customer', 'experience optimization']
        },
        skillsCore: {
          vi: ['product thinking', 'user research', 'wireframing', 'phân tích dữ liệu', 'storytelling'],
          en: ['product thinking', 'user research', 'wireframing', 'data analysis', 'storytelling']
        },
        focus: { vi: 'sản phẩm và trải nghiệm', en: 'product and experience' }
      }),
      buildCluster({
        id: 'moc-content',
        title: { vi: 'Nội dung & Truyền thông', en: 'Content & Media' },
        summary: {
          vi: 'Phù hợp sáng tạo nội dung nuôi dưỡng cộng đồng và thương hiệu.',
          en: 'Ideal for storytelling that nurtures community and brand presence.'
        },
        keyword: { vi: 'nội dung', en: 'Content' },
        tags: {
          vi: ['content', 'truyền thông', 'sáng tạo', 'chiến dịch', 'community'],
          en: ['content', 'media', 'creative', 'campaigns', 'community']
        },
        skillsCore: {
          vi: ['storytelling', 'copywriting', 'biên tập', 'social media', 'quản trị thương hiệu'],
          en: ['storytelling', 'copywriting', 'editing', 'social media', 'brand management']
        },
        focus: { vi: 'nội dung và truyền thông', en: 'content and media' }
      }),
      buildCluster({
        id: 'moc-community',
        title: { vi: 'Cộng đồng & Nhân sự', en: 'Community & People' },
        summary: {
          vi: 'Gắn kết con người, phát triển văn hóa và sức khỏe tổ chức.',
          en: 'Connects people, grows culture, and sustains organizational health.'
        },
        keyword: { vi: 'cộng đồng', en: 'Community' },
        tags: {
          vi: ['HR', 'văn hóa', 'gắn kết', 'people ops', 'phát triển tổ chức'],
          en: ['HR', 'culture', 'engagement', 'people ops', 'org development']
        },
        skillsCore: {
          vi: ['giao tiếp', 'tổ chức sự kiện', 'đàm phán', 'phát triển văn hóa', 'lắng nghe'],
          en: ['communication', 'event hosting', 'negotiation', 'culture building', 'listening']
        },
        focus: { vi: 'cộng đồng và nhân sự', en: 'community and people' }
      }),
      buildCluster({
        id: 'moc-sustainability',
        title: { vi: 'Nông nghiệp & Bền vững', en: 'Agriculture & Sustainability' },
        summary: {
          vi: 'Phát triển môi trường, hệ sinh thái và chuỗi giá trị xanh.',
          en: 'Builds green ecosystems and sustainable value chains.'
        },
        keyword: { vi: 'nông nghiệp', en: 'Agriculture' },
        tags: {
          vi: ['môi trường', 'bền vững', 'ESG', 'nông nghiệp', 'chuỗi cung ứng xanh'],
          en: ['environment', 'sustainability', 'ESG', 'agriculture', 'green supply chain']
        },
        skillsCore: {
          vi: ['quản lý dự án', 'hiểu biết sinh thái', 'phân tích dữ liệu', 'vận hành thực địa', 'đo lường tác động'],
          en: ['project management', 'ecology knowledge', 'data analysis', 'field operations', 'impact measurement']
        },
        focus: { vi: 'nông nghiệp và bền vững', en: 'agriculture and sustainability' }
      }),
      buildCluster({
        id: 'moc-wellness',
        title: { vi: 'Sức khỏe & Wellness', en: 'Health & Wellness' },
        summary: {
          vi: 'Chú trọng chăm sóc, phục hồi và nâng cao chất lượng sống.',
          en: 'Focuses on care, recovery, and quality-of-life uplift.'
        },
        keyword: { vi: 'wellness', en: 'Wellness' },
        tags: {
          vi: ['chăm sóc sức khỏe', 'wellness', 'dịch vụ', 'tư vấn', 'phòng ngừa'],
          en: ['healthcare', 'wellness', 'services', 'consulting', 'prevention']
        },
        skillsCore: {
          vi: ['chăm sóc khách hàng', 'tư vấn', 'đánh giá nhu cầu', 'chăm sóc toàn diện', 'đạo đức nghề nghiệp'],
          en: ['customer care', 'consulting', 'needs assessment', 'holistic care', 'professional ethics']
        },
        focus: { vi: 'sức khỏe và wellness', en: 'health and wellness' }
      }),
      buildCluster({
        id: 'moc-research',
        title: { vi: 'Nghiên cứu & Chính sách', en: 'Research & Policy' },
        summary: {
          vi: 'Đào sâu tri thức, định hướng chính sách dài hạn.',
          en: 'Deep knowledge work and long-term policy direction.'
        },
        keyword: { vi: 'nghiên cứu', en: 'Research' },
        tags: {
          vi: ['phân tích', 'chính sách', 'báo cáo', 'định hướng', 'tác động xã hội'],
          en: ['analysis', 'policy', 'reports', 'direction', 'social impact']
        },
        skillsCore: {
          vi: ['tư duy phản biện', 'viết báo cáo', 'phân tích dữ liệu', 'đánh giá tác động', 'thuyết trình'],
          en: ['critical thinking', 'report writing', 'data analysis', 'impact evaluation', 'presentation']
        },
        focus: { vi: 'nghiên cứu và chính sách', en: 'research and policy' }
      }),
      buildCluster({
        id: 'moc-social-impact',
        title: { vi: 'Xã hội & Phi lợi nhuận', en: 'Social Impact & Nonprofit' },
        summary: {
          vi: 'Hướng đến cộng đồng, tạo giá trị nhân văn dài hạn.',
          en: 'Community-oriented work with long-term humanitarian value.'
        },
        keyword: { vi: 'xã hội', en: 'Social Impact' },
        tags: {
          vi: ['phi lợi nhuận', 'CSR', 'dự án cộng đồng', 'gây quỹ', 'phát triển bền vững'],
          en: ['nonprofit', 'CSR', 'community projects', 'fundraising', 'sustainability']
        },
        skillsCore: {
          vi: ['quản lý dự án', 'giao tiếp cộng đồng', 'gây quỹ', 'đánh giá hiệu quả', 'đối tác'],
          en: ['project management', 'community engagement', 'fundraising', 'impact evaluation', 'partnerships']
        },
        focus: { vi: 'tác động xã hội', en: 'social impact' }
      })
    ]
  },
  'Hỏa': {
    element: { vi: 'Hỏa', en: 'Fire' },
    clusters: [
      buildCluster({
        id: 'hoa-sales-growth',
        title: { vi: 'Sales & Tăng trưởng', en: 'Sales & Growth' },
        summary: {
          vi: 'Tăng tốc doanh số, mở rộng thị trường và bứt phá nhanh.',
          en: 'Accelerates revenue and expansion with fast execution.'
        },
        keyword: { vi: 'kinh doanh', en: 'Sales' },
        tags: {
          vi: ['sales', 'growth', 'đàm phán', 'bứt phá', 'thị trường'],
          en: ['sales', 'growth', 'negotiation', 'scaling', 'market']
        },
        skillsCore: {
          vi: ['chốt sale', 'thuyết phục', 'pipeline', 'đàm phán', 'tư duy mục tiêu'],
          en: ['closing', 'persuasion', 'pipeline', 'negotiation', 'goal mindset']
        },
        focus: { vi: 'sales và tăng trưởng', en: 'sales and growth' }
      }),
      buildCluster({
        id: 'hoa-branding',
        title: { vi: 'Marketing & Branding', en: 'Marketing & Branding' },
        summary: {
          vi: 'Khuếch đại hình ảnh, tạo hiệu ứng truyền thông mạnh.',
          en: 'Amplifies brand presence and high-impact communication.'
        },
        keyword: { vi: 'marketing', en: 'Marketing' },
        tags: {
          vi: ['branding', 'truyền thông', 'chiến dịch', 'viral', 'thương hiệu'],
          en: ['branding', 'communications', 'campaigns', 'viral', 'brand']
        },
        skillsCore: {
          vi: ['brand strategy', 'content planning', 'digital ads', 'PR', 'insight khách hàng'],
          en: ['brand strategy', 'content planning', 'digital ads', 'PR', 'customer insight']
        },
        focus: { vi: 'marketing và branding', en: 'marketing and branding' }
      }),
      buildCluster({
        id: 'hoa-entertainment',
        title: { vi: 'Giải trí & Nghệ thuật', en: 'Entertainment & Arts' },
        summary: {
          vi: 'Thể hiện sáng tạo, biểu diễn và lan tỏa cảm xúc.',
          en: 'Showcases creativity, performance, and emotional impact.'
        },
        keyword: { vi: 'nghệ thuật', en: 'Arts' },
        tags: {
          vi: ['sáng tạo', 'giải trí', 'biểu diễn', 'production', 'truyền cảm hứng'],
          en: ['creative', 'entertainment', 'performance', 'production', 'inspiration']
        },
        skillsCore: {
          vi: ['biểu diễn', 'kịch bản', 'đạo diễn', 'sản xuất', 'quản trị nghệ sĩ'],
          en: ['performance', 'scriptwriting', 'directing', 'production', 'artist management']
        },
        focus: { vi: 'nghệ thuật và giải trí', en: 'arts and entertainment' }
      }),
      buildCluster({
        id: 'hoa-leadership',
        title: { vi: 'Lãnh đạo & Quản trị', en: 'Leadership & Management' },
        summary: {
          vi: 'Dẫn dắt đội ngũ, tạo khí thế và mục tiêu rõ ràng.',
          en: 'Leads teams with momentum and clear goals.'
        },
        keyword: { vi: 'lãnh đạo', en: 'Leadership' },
        tags: {
          vi: ['leadership', 'quản trị', 'định hướng', 'ra quyết định', 'truyền cảm hứng'],
          en: ['leadership', 'management', 'direction', 'decision-making', 'inspiration']
        },
        skillsCore: {
          vi: ['lãnh đạo đội nhóm', 'ra quyết định', 'giao tiếp', 'chiến lược', 'coaching'],
          en: ['team leadership', 'decision making', 'communication', 'strategy', 'coaching']
        },
        focus: { vi: 'lãnh đạo và quản trị', en: 'leadership and management' }
      }),
      buildCluster({
        id: 'hoa-startup',
        title: { vi: 'Khởi nghiệp & Đổi mới', en: 'Startup & Innovation' },
        summary: {
          vi: 'Thích hợp môi trường tốc độ cao, nhiều thử nghiệm.',
          en: 'Fits high-speed environments with rapid experimentation.'
        },
        keyword: { vi: 'khởi nghiệp', en: 'Startup' },
        tags: {
          vi: ['đổi mới', 'pivot', 'tốc độ', 'tăng trưởng nhanh', 'founder'],
          en: ['innovation', 'pivot', 'speed', 'rapid growth', 'founder']
        },
        skillsCore: {
          vi: ['tư duy lean', 'điều hành', 'gọi vốn', 'product-market fit', 'thích nghi'],
          en: ['lean mindset', 'operations', 'fundraising', 'product-market fit', 'adaptability']
        },
        focus: { vi: 'khởi nghiệp và đổi mới', en: 'startup and innovation' }
      }),
      buildCluster({
        id: 'hoa-events',
        title: { vi: 'Sự kiện & Trải nghiệm', en: 'Events & Experience' },
        summary: {
          vi: 'Tạo trải nghiệm bùng nổ, cảm xúc mạnh cho khách hàng.',
          en: 'Creates high-energy experiences and emotional impact.'
        },
        keyword: { vi: 'sự kiện', en: 'Events' },
        tags: {
          vi: ['event', 'activation', 'trải nghiệm', 'tổ chức', 'branding'],
          en: ['event', 'activation', 'experience', 'organization', 'branding']
        },
        skillsCore: {
          vi: ['tổ chức sự kiện', 'quản lý nhà cung cấp', 'timeline', 'sáng tạo trải nghiệm', 'quản trị rủi ro'],
          en: ['event planning', 'vendor management', 'timeline', 'experience design', 'risk management']
        },
        focus: { vi: 'sự kiện và trải nghiệm', en: 'events and experience' }
      }),
      buildCluster({
        id: 'hoa-hospitality',
        title: { vi: 'Dịch vụ & Hospitality', en: 'Service & Hospitality' },
        summary: {
          vi: 'Đón tiếp, chăm sóc khách hàng với năng lượng tích cực.',
          en: 'Delivers energetic hospitality and customer care.'
        },
        keyword: { vi: 'dịch vụ', en: 'Hospitality' },
        tags: {
          vi: ['khách sạn', 'dịch vụ', 'trải nghiệm', 'chăm sóc', 'tốc độ'],
          en: ['hotel', 'service', 'experience', 'care', 'speed']
        },
        skillsCore: {
          vi: ['customer service', 'xử lý tình huống', 'giao tiếp', 'quản lý lịch trình', 'upsell'],
          en: ['customer service', 'problem solving', 'communication', 'schedule management', 'upsell']
        },
        focus: { vi: 'dịch vụ và hospitality', en: 'service and hospitality' }
      }),
      buildCluster({
        id: 'hoa-coaching',
        title: { vi: 'Huấn luyện & Truyền cảm hứng', en: 'Coaching & Inspiration' },
        summary: {
          vi: 'Truyền lửa, thúc đẩy hiệu suất và tinh thần đội nhóm.',
          en: 'Energizes teams and boosts performance.'
        },
        keyword: { vi: 'huấn luyện', en: 'Coaching' },
        tags: {
          vi: ['coaching', 'động lực', 'đào tạo', 'thuyết trình', 'kỹ năng mềm'],
          en: ['coaching', 'motivation', 'training', 'public speaking', 'soft skills']
        },
        skillsCore: {
          vi: ['huấn luyện', 'tư duy tích cực', 'facilitation', 'feedback', 'đặt mục tiêu'],
          en: ['coaching', 'positive mindset', 'facilitation', 'feedback', 'goal setting']
        },
        focus: { vi: 'huấn luyện và truyền cảm hứng', en: 'coaching and inspiration' }
      })
    ]
  },
  'Thổ': {
    element: { vi: 'Thổ', en: 'Earth' },
    clusters: [
      buildCluster({
        id: 'tho-real-estate',
        title: { vi: 'Bất động sản & Xây dựng', en: 'Real Estate & Construction' },
        summary: {
          vi: 'Xây nền tảng vật chất, dự án dài hạn và ổn định.',
          en: 'Builds physical foundations and long-term projects.'
        },
        keyword: { vi: 'bất động sản', en: 'Real Estate' },
        tags: {
          vi: ['xây dựng', 'dự án', 'quy hoạch', 'tài sản', 'đầu tư'],
          en: ['construction', 'projects', 'planning', 'assets', 'investment']
        },
        skillsCore: {
          vi: ['quản lý dự án', 'đọc bản vẽ', 'đấu thầu', 'giám sát thi công', 'kiểm soát chi phí'],
          en: ['project management', 'blueprint reading', 'bidding', 'site supervision', 'cost control']
        },
        focus: { vi: 'bất động sản và xây dựng', en: 'real estate and construction' }
      }),
      buildCluster({
        id: 'tho-operations',
        title: { vi: 'Vận hành & Quản lý dự án', en: 'Operations & Project Management' },
        summary: {
          vi: 'Ổn định quy trình, đảm bảo tiến độ và hiệu suất.',
          en: 'Stabilizes processes and ensures delivery.'
        },
        keyword: { vi: 'vận hành', en: 'Operations' },
        tags: {
          vi: ['quy trình', 'kỷ luật', 'tối ưu', 'KPIs', 'ổn định'],
          en: ['process', 'discipline', 'optimization', 'KPIs', 'stability']
        },
        skillsCore: {
          vi: ['quản lý dự án', 'quy trình', 'phân bổ nguồn lực', 'reporting', 'tối ưu chi phí'],
          en: ['project management', 'process design', 'resource allocation', 'reporting', 'cost optimization']
        },
        focus: { vi: 'vận hành và quản lý dự án', en: 'operations and project management' }
      }),
      buildCluster({
        id: 'tho-finance',
        title: { vi: 'Tài chính & Kế toán', en: 'Finance & Accounting' },
        summary: {
          vi: 'Quản trị tài chính chặt chẽ, ưu tiên an toàn.',
          en: 'Controls finance tightly with risk awareness.'
        },
        keyword: { vi: 'kế toán', en: 'Accounting' },
        tags: {
          vi: ['kế toán', 'kiểm soát', 'ngân sách', 'báo cáo', 'tuân thủ'],
          en: ['accounting', 'control', 'budgeting', 'reporting', 'compliance']
        },
        skillsCore: {
          vi: ['lập báo cáo tài chính', 'kiểm soát nội bộ', 'thuế', 'phân tích chi phí', 'chuẩn mực'],
          en: ['financial reporting', 'internal control', 'tax', 'cost analysis', 'standards']
        },
        focus: { vi: 'tài chính và kế toán', en: 'finance and accounting' }
      }),
      buildCluster({
        id: 'tho-supply-chain',
        title: { vi: 'Chuỗi cung ứng & Logistics', en: 'Supply Chain & Logistics' },
        summary: {
          vi: 'Đảm bảo dòng chảy hàng hóa ổn định, tối ưu tồn kho.',
          en: 'Keeps supply flow stable and optimized.'
        },
        keyword: { vi: 'logistics', en: 'Logistics' },
        tags: {
          vi: ['chuỗi cung ứng', 'kho vận', 'vận tải', 'tồn kho', 'điều phối'],
          en: ['supply chain', 'warehouse', 'transport', 'inventory', 'coordination']
        },
        skillsCore: {
          vi: ['forecast nhu cầu', 'quản lý tồn kho', 'điều phối vận tải', 'ERP', 'đàm phán nhà cung cấp'],
          en: ['demand forecasting', 'inventory management', 'transport coordination', 'ERP', 'supplier negotiation']
        },
        focus: { vi: 'chuỗi cung ứng và logistics', en: 'supply chain and logistics' }
      }),
      buildCluster({
        id: 'tho-compliance',
        title: { vi: 'Pháp chế & Compliance', en: 'Legal & Compliance' },
        summary: {
          vi: 'Bảo vệ tổ chức bằng quy chuẩn và rủi ro pháp lý.',
          en: 'Protects organizations through standards and legal risk control.'
        },
        keyword: { vi: 'pháp chế', en: 'Legal' },
        tags: {
          vi: ['pháp lý', 'compliance', 'chuẩn hóa', 'hợp đồng', 'rủi ro'],
          en: ['legal', 'compliance', 'standardization', 'contracts', 'risk']
        },
        skillsCore: {
          vi: ['soạn thảo hợp đồng', 'đánh giá rủi ro', 'tuân thủ', 'pháp luật doanh nghiệp', 'kiểm tra nội bộ'],
          en: ['contract drafting', 'risk assessment', 'compliance', 'corporate law', 'internal audit']
        },
        focus: { vi: 'pháp chế và compliance', en: 'legal and compliance' }
      }),
      buildCluster({
        id: 'tho-infrastructure',
        title: { vi: 'Hạ tầng & Quy hoạch', en: 'Infrastructure & Planning' },
        summary: {
          vi: 'Phát triển đô thị, hạ tầng kỹ thuật và chiến lược dài hạn.',
          en: 'Develops urban planning and long-term infrastructure.'
        },
        keyword: { vi: 'hạ tầng', en: 'Infrastructure' },
        tags: {
          vi: ['quy hoạch', 'đô thị', 'kỹ thuật', 'dự án công', 'chiến lược'],
          en: ['planning', 'urban', 'engineering', 'public projects', 'strategy']
        },
        skillsCore: {
          vi: ['quy hoạch', 'phân tích dữ liệu', 'giám sát', 'quản lý stakeholder', 'quản trị rủi ro'],
          en: ['planning', 'data analysis', 'monitoring', 'stakeholder management', 'risk management']
        },
        focus: { vi: 'hạ tầng và quy hoạch', en: 'infrastructure and planning' }
      }),
      buildCluster({
        id: 'tho-risk',
        title: { vi: 'Quản trị rủi ro & QA', en: 'Risk Management & QA' },
        summary: {
          vi: 'Kiểm soát chất lượng, giảm sai sót và bảo vệ hệ thống.',
          en: 'Controls quality, reduces errors, and protects systems.'
        },
        keyword: { vi: 'quản trị rủi ro', en: 'Risk' },
        tags: {
          vi: ['QA', 'kiểm định', 'an toàn', 'rủi ro', 'tiêu chuẩn'],
          en: ['QA', 'inspection', 'safety', 'risk', 'standards']
        },
        skillsCore: {
          vi: ['kiểm thử', 'quản lý chất lượng', 'phân tích rủi ro', 'quy trình', 'audit'],
          en: ['testing', 'quality management', 'risk analysis', 'process', 'audit']
        },
        focus: { vi: 'quản trị rủi ro và QA', en: 'risk management and QA' }
      }),
      buildCluster({
        id: 'tho-admin',
        title: { vi: 'Hành chính & Văn phòng', en: 'Administration & Office' },
        summary: {
          vi: 'Giữ nhịp vận hành hậu cần, đảm bảo nền tảng ổn định.',
          en: 'Keeps back-office stability and smooth operations.'
        },
        keyword: { vi: 'hành chính', en: 'Administration' },
        tags: {
          vi: ['hậu cần', 'quản trị văn phòng', 'quy trình', 'dịch vụ nội bộ', 'ổn định'],
          en: ['back office', 'office management', 'process', 'internal service', 'stability']
        },
        skillsCore: {
          vi: ['tổ chức', 'quản lý hồ sơ', 'giao tiếp', 'quy trình', 'hỗ trợ vận hành'],
          en: ['organization', 'documentation', 'communication', 'process', 'operations support']
        },
        focus: { vi: 'hành chính và văn phòng', en: 'administration and office operations' }
      })
    ]
  },
  'Kim': {
    element: { vi: 'Kim', en: 'Metal' },
    clusters: [
      buildCluster({
        id: 'kim-finance',
        title: { vi: 'Tài chính & Đầu tư', en: 'Finance & Investment' },
        summary: {
          vi: 'Tư duy kỷ luật, tối ưu vốn và kiểm soát rủi ro.',
          en: 'Disciplined capital optimization and risk control.'
        },
        keyword: { vi: 'đầu tư', en: 'Investment' },
        tags: {
          vi: ['tài chính', 'đầu tư', 'phân tích', 'tối ưu', 'kỷ luật'],
          en: ['finance', 'investment', 'analysis', 'optimization', 'discipline']
        },
        skillsCore: {
          vi: ['phân tích tài chính', 'định giá', 'quản trị danh mục', 'risk management', 'tư duy dữ liệu'],
          en: ['financial analysis', 'valuation', 'portfolio management', 'risk management', 'data mindset']
        },
        focus: { vi: 'tài chính và đầu tư', en: 'finance and investment' }
      }),
      buildCluster({
        id: 'kim-law',
        title: { vi: 'Luật & Quy chuẩn', en: 'Law & Standards' },
        summary: {
          vi: 'Giữ kỷ cương, tối ưu hệ thống qua chuẩn hóa.',
          en: 'Maintains order through standards and compliance.'
        },
        keyword: { vi: 'luật', en: 'Law' },
        tags: {
          vi: ['pháp lý', 'chuẩn hóa', 'điều khoản', 'tuân thủ', 'bảo vệ'],
          en: ['legal', 'standardization', 'clauses', 'compliance', 'protection']
        },
        skillsCore: {
          vi: ['pháp chế', 'soạn thảo', 'đàm phán hợp đồng', 'tuân thủ', 'tư duy logic'],
          en: ['legal drafting', 'contract negotiation', 'compliance', 'logical reasoning', 'governance']
        },
        focus: { vi: 'luật và quy chuẩn', en: 'law and standards' }
      }),
      buildCluster({
        id: 'kim-engineering',
        title: { vi: 'Kỹ thuật & Sản xuất', en: 'Engineering & Manufacturing' },
        summary: {
          vi: 'Tối ưu quy trình sản xuất, chú trọng hiệu suất.',
          en: 'Optimizes manufacturing processes and efficiency.'
        },
        keyword: { vi: 'kỹ thuật', en: 'Engineering' },
        tags: {
          vi: ['kỹ thuật', 'sản xuất', 'tối ưu', 'chất lượng', 'tự động hóa'],
          en: ['engineering', 'manufacturing', 'optimization', 'quality', 'automation']
        },
        skillsCore: {
          vi: ['thiết kế kỹ thuật', 'vận hành máy', 'lean manufacturing', 'safety', 'kỷ luật'],
          en: ['engineering design', 'machine operations', 'lean manufacturing', 'safety', 'discipline']
        },
        focus: { vi: 'kỹ thuật và sản xuất', en: 'engineering and manufacturing' }
      }),
      buildCluster({
        id: 'kim-cyber',
        title: { vi: 'An ninh & Hạ tầng IT', en: 'Cybersecurity & IT Ops' },
        summary: {
          vi: 'Kiểm soát hệ thống, đảm bảo an toàn và ổn định.',
          en: 'Secures systems with strict operational control.'
        },
        keyword: { vi: 'an ninh mạng', en: 'Cybersecurity' },
        tags: {
          vi: ['bảo mật', 'hạ tầng', 'ops', 'monitoring', 'kỷ luật'],
          en: ['security', 'infrastructure', 'ops', 'monitoring', 'discipline']
        },
        skillsCore: {
          vi: ['network', 'incident response', 'hardening', 'log monitoring', 'tuân thủ'],
          en: ['networking', 'incident response', 'hardening', 'log monitoring', 'compliance']
        },
        focus: { vi: 'an ninh mạng và hạ tầng', en: 'cybersecurity and IT operations' }
      }),
      buildCluster({
        id: 'kim-analytics',
        title: { vi: 'Dữ liệu & Phân tích', en: 'Data & Analytics' },
        summary: {
          vi: 'Tối ưu quyết định dựa trên dữ liệu, đo lường chính xác.',
          en: 'Optimizes decisions with precise data analysis.'
        },
        keyword: { vi: 'dữ liệu', en: 'Data' },
        tags: {
          vi: ['data', 'analytics', 'BI', 'đo lường', 'tối ưu'],
          en: ['data', 'analytics', 'BI', 'measurement', 'optimization']
        },
        skillsCore: {
          vi: ['SQL', 'dashboard', 'phân tích thống kê', 'data modeling', 'trình bày dữ liệu'],
          en: ['SQL', 'dashboards', 'statistical analysis', 'data modeling', 'data storytelling']
        },
        focus: { vi: 'dữ liệu và phân tích', en: 'data and analytics' }
      }),
      buildCluster({
        id: 'kim-quality',
        title: { vi: 'Chất lượng & Kiểm định', en: 'Quality & Inspection' },
        summary: {
          vi: 'Đảm bảo tiêu chuẩn, giảm lỗi và nâng hiệu suất.',
          en: 'Ensures standards, reduces defects, and boosts performance.'
        },
        keyword: { vi: 'kiểm định', en: 'Quality' },
        tags: {
          vi: ['QA', 'QC', 'tiêu chuẩn', 'audit', 'quy trình'],
          en: ['QA', 'QC', 'standards', 'audit', 'process']
        },
        skillsCore: {
          vi: ['QA/QC', 'kiểm thử', 'iso', 'phân tích lỗi', 'continuous improvement'],
          en: ['QA/QC', 'testing', 'ISO', 'defect analysis', 'continuous improvement']
        },
        focus: { vi: 'chất lượng và kiểm định', en: 'quality and inspection' }
      }),
      buildCluster({
        id: 'kim-procurement',
        title: { vi: 'Mua sắm & Đàm phán', en: 'Procurement & Negotiation' },
        summary: {
          vi: 'Tối ưu chi phí, kiểm soát hợp đồng và nguồn cung.',
          en: 'Optimizes cost through strong negotiation and sourcing.'
        },
        keyword: { vi: 'mua sắm', en: 'Procurement' },
        tags: {
          vi: ['procurement', 'sourcing', 'đàm phán', 'giá', 'hợp đồng'],
          en: ['procurement', 'sourcing', 'negotiation', 'pricing', 'contracts']
        },
        skillsCore: {
          vi: ['đàm phán', 'phân tích chi phí', 'sourcing', 'quản lý nhà cung cấp', 'quy trình'],
          en: ['negotiation', 'cost analysis', 'sourcing', 'vendor management', 'process']
        },
        focus: { vi: 'mua sắm và đàm phán', en: 'procurement and negotiation' }
      }),
      buildCluster({
        id: 'kim-medtech',
        title: { vi: 'Y sinh & Công nghệ chính xác', en: 'MedTech & Precision' },
        summary: {
          vi: 'Đòi hỏi chuẩn xác, tuân thủ và kỹ thuật cao.',
          en: 'Precision-focused work with strict compliance and technical depth.'
        },
        keyword: { vi: 'y sinh', en: 'MedTech' },
        tags: {
          vi: ['y sinh', 'thiết bị', 'chuẩn hóa', 'an toàn', 'precision'],
          en: ['medtech', 'devices', 'standards', 'safety', 'precision']
        },
        skillsCore: {
          vi: ['R&D', 'quy chuẩn y tế', 'kiểm định', 'kỹ thuật chính xác', 'documentation'],
          en: ['R&D', 'medical standards', 'validation', 'precision engineering', 'documentation']
        },
        focus: { vi: 'y sinh và công nghệ chính xác', en: 'medtech and precision technology' }
      })
    ]
  },
  'Thủy': {
    element: { vi: 'Thủy', en: 'Water' },
    clusters: [
      buildCluster({
        id: 'thuy-tech-data',
        title: { vi: 'Công nghệ & Dữ liệu', en: 'Technology & Data' },
        summary: {
          vi: 'Dòng chảy thông tin, phân tích sâu và linh hoạt.',
          en: 'Information flow with deep analysis and flexibility.'
        },
        keyword: { vi: 'công nghệ', en: 'Technology' },
        tags: {
          vi: ['IT', 'data', 'linh hoạt', 'bảo mật', 'phân tích'],
          en: ['IT', 'data', 'flexible', 'security', 'analysis']
        },
        skillsCore: {
          vi: ['coding', 'data pipeline', 'problem solving', 'cloud', 'tư duy hệ thống'],
          en: ['coding', 'data pipelines', 'problem solving', 'cloud', 'systems thinking']
        },
        focus: { vi: 'công nghệ và dữ liệu', en: 'technology and data' }
      }),
      buildCluster({
        id: 'thuy-research-strategy',
        title: { vi: 'Nghiên cứu & Chiến lược', en: 'Research & Strategy' },
        summary: {
          vi: 'Phân tích bối cảnh, định hướng chiến lược dài hạn.',
          en: 'Analyzes context and shapes long-term strategy.'
        },
        keyword: { vi: 'chiến lược', en: 'Strategy' },
        tags: {
          vi: ['phân tích', 'chiến lược', 'dự báo', 'tổng hợp', 'insight'],
          en: ['analysis', 'strategy', 'forecasting', 'synthesis', 'insight']
        },
        skillsCore: {
          vi: ['research', 'market analysis', 'business modeling', 'insight', 'storytelling'],
          en: ['research', 'market analysis', 'business modeling', 'insight', 'storytelling']
        },
        focus: { vi: 'nghiên cứu và chiến lược', en: 'research and strategy' }
      }),
      buildCluster({
        id: 'thuy-consulting',
        title: { vi: 'Tư vấn & Coaching', en: 'Consulting & Coaching' },
        summary: {
          vi: 'Linh hoạt theo nhu cầu khách hàng, giải bài toán phức tạp.',
          en: 'Flexible advisory work for complex challenges.'
        },
        keyword: { vi: 'tư vấn', en: 'Consulting' },
        tags: {
          vi: ['consulting', 'đồng hành', 'giải pháp', 'khách hàng', 'linh hoạt'],
          en: ['consulting', 'advisory', 'solutions', 'clients', 'flexibility']
        },
        skillsCore: {
          vi: ['problem solving', 'facilitation', 'phân tích', 'presentation', 'stakeholder'],
          en: ['problem solving', 'facilitation', 'analysis', 'presentation', 'stakeholder management']
        },
        focus: { vi: 'tư vấn và coaching', en: 'consulting and coaching' }
      }),
      buildCluster({
        id: 'thuy-logistics-trade',
        title: { vi: 'Logistics & Thương mại', en: 'Logistics & Trade' },
        summary: {
          vi: 'Dòng chảy hàng hóa, thương mại và điều phối linh hoạt.',
          en: 'Manages flow of goods, trade, and adaptive coordination.'
        },
        keyword: { vi: 'thương mại', en: 'Trade' },
        tags: {
          vi: ['thương mại', 'logistics', 'vận tải', 'tối ưu tuyến', 'điều phối'],
          en: ['trade', 'logistics', 'transport', 'route optimization', 'coordination']
        },
        skillsCore: {
          vi: ['điều phối', 'hải quan', 'tối ưu chi phí', 'đàm phán', 'quản lý đối tác'],
          en: ['coordination', 'customs', 'cost optimization', 'negotiation', 'partner management']
        },
        focus: { vi: 'logistics và thương mại', en: 'logistics and trade' }
      }),
      buildCluster({
        id: 'thuy-ux-insights',
        title: { vi: 'UX Research & Insight', en: 'UX Research & Insight' },
        summary: {
          vi: 'Đào sâu hành vi người dùng, khai thác dữ liệu và cảm xúc.',
          en: 'Deep user insight with behavioral and emotional analysis.'
        },
        keyword: { vi: 'UX research', en: 'UX Research' },
        tags: {
          vi: ['user research', 'insight', 'data', 'phỏng vấn', 'synthesis'],
          en: ['user research', 'insight', 'data', 'interviews', 'synthesis']
        },
        skillsCore: {
          vi: ['phỏng vấn', 'điều phối nghiên cứu', 'phân tích định tính', 'báo cáo', 'storytelling'],
          en: ['interviews', 'research ops', 'qualitative analysis', 'reporting', 'storytelling']
        },
        focus: { vi: 'ux research và insight', en: 'ux research and insight' }
      }),
      buildCluster({
        id: 'thuy-writing-media',
        title: { vi: 'Viết lách & Truyền thông', en: 'Writing & Communication' },
        summary: {
          vi: 'Dẫn dắt thông tin, kể chuyện, xây dựng niềm tin.',
          en: 'Leads information flow, storytelling, and trust building.'
        },
        keyword: { vi: 'truyền thông', en: 'Communication' },
        tags: {
          vi: ['writing', 'content', 'báo chí', 'truyền thông', 'storytelling'],
          en: ['writing', 'content', 'journalism', 'communications', 'storytelling']
        },
        skillsCore: {
          vi: ['viết bài', 'biên tập', 'nghiên cứu', 'phỏng vấn', 'xuất bản'],
          en: ['writing', 'editing', 'research', 'interviews', 'publishing']
        },
        focus: { vi: 'viết lách và truyền thông', en: 'writing and communication' }
      }),
      buildCluster({
        id: 'thuy-health-care',
        title: { vi: 'Chăm sóc & Điều dưỡng', en: 'Care & Nursing' },
        summary: {
          vi: 'Tập trung chăm sóc sâu, lắng nghe và hỗ trợ dài hạn.',
          en: 'Deep care, listening, and long-term support roles.'
        },
        keyword: { vi: 'chăm sóc', en: 'Care' },
        tags: {
          vi: ['điều dưỡng', 'chăm sóc', 'tư vấn', 'phục hồi', 'dịch vụ'],
          en: ['nursing', 'care', 'consulting', 'rehabilitation', 'services']
        },
        skillsCore: {
          vi: ['lắng nghe', 'kiến thức y tế', 'hỗ trợ tâm lý', 'quy trình chăm sóc', 'đạo đức'],
          en: ['active listening', 'medical knowledge', 'psychological support', 'care protocols', 'ethics']
        },
        focus: { vi: 'chăm sóc và điều dưỡng', en: 'care and nursing' }
      }),
      buildCluster({
        id: 'thuy-travel-hospitality',
        title: { vi: 'Du lịch & Lữ hành', en: 'Travel & Hospitality' },
        summary: {
          vi: 'Linh hoạt, nhạy với trải nghiệm và dòng chảy dịch vụ.',
          en: 'Flexible and experience-focused within service flows.'
        },
        keyword: { vi: 'du lịch', en: 'Travel' },
        tags: {
          vi: ['du lịch', 'lữ hành', 'dịch vụ', 'trải nghiệm', 'văn hóa'],
          en: ['travel', 'tourism', 'service', 'experience', 'culture']
        },
        skillsCore: {
          vi: ['lập tour', 'chăm sóc khách', 'ngoại ngữ', 'giải quyết sự cố', 'kỹ năng giao tiếp'],
          en: ['tour planning', 'customer care', 'languages', 'issue resolution', 'communication']
        },
        focus: { vi: 'du lịch và lữ hành', en: 'travel and hospitality' }
      })
    ]
  }
};

export const getDominantElementCareerData = (element) => DOMINANT_ELEMENT_CAREERS[element] || null;

